import { createContext } from 'react';

export interface EditProfileContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const EditProfileContext = createContext<EditProfileContextType | undefined>(undefined);
